"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.youtubeDetails = exports.youtubeDetailsResultSchema = exports.youtubeDetailsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.youtubeDetailsArgsSchema = zod_1.z.object({
    videoId: zod_1.z.string().describe('The YouTube video ID to fetch details for'),
    emitMode: common_1.emitModeSchema.describe('The mode to emit the details in.'),
});
exports.youtubeDetailsResultSchema = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    description: zod_1.z.string(),
    channel: zod_1.z.string(),
    duration: zod_1.z.string(),
    viewCount: zod_1.z.number(),
    likeCount: zod_1.z.number(),
    commentCount: zod_1.z.number(),
    thumbnail: zod_1.z.string(),
    tags: zod_1.z.array(zod_1.z.string()),
    publishedAt: zod_1.z.string().nullable(),
});
exports.youtubeDetails = (0, common_1.createEmitModeToolMetadata)({
    id: 'youtubeDetails',
    displayName: 'YouTube Details',
    displayDescription: 'Fetch details for a YouTube video.',
    category: 'search',
    color: common_1.BRAND_COLORS.YOUTUBE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.YOUTUBE),
    icon: 'youtube',
    argsSchema: exports.youtubeDetailsArgsSchema,
}, exports.youtubeDetailsResultSchema);
